package com.evoapps.evoshift.domain.usecase.financial

import com.evoapps.evoshift.domain.repository.FinancialRepository

data class LaborKpi(
    val revenue: Double,
    val laborCost: Double,
    val percentage: Double // np. 28.5 (oznacza 28.5%)
)

class GetRealTimeLaborPercentageUseCase(
    private val financialRepository: FinancialRepository
) {
    suspend operator fun invoke(dailyRecordId: String): Result<LaborKpi> {
        return try {
            // 1. Pobierz rekord dnia (zawiera wpisany utarg i zagregowany koszt pracy)
            val dailyRecord = financialRepository.getDailyRecord(dailyRecordId).getOrThrow()

            val revenue = dailyRecord.revenue.realNetto ?: 0.0 // Jeśli brak utargu, to 0
            val laborCost = dailyRecord.costs.actualByContractType.values.sum()

            // 2. Zabezpieczenie przed dzieleniem przez zero
            val percentage = if (revenue > 0) {
                (laborCost / revenue) * 100
            } else {
                0.0 // Lub null, zależnie od logiki UI
            }

            // 3. Zwracamy obliczone KPI
            Result.success(LaborKpi(revenue, laborCost, percentage))
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}